module.exports = __webpack_public_path__ + "img/15_31.686d2a73.png";